<script setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import {usePolicyMenuStore} from "../../pages/user/stores/policy/menuStore";
import _ from "lodash";

const route = useRoute()

onMounted(()=>{
  const menuStore = usePolicyMenuStore()
  menuList.value = menuStore.menuList;
})
const menuList = ref([])

const onClickMenu = (e, menu) => {
  if(e.target.closest('.sub-title') === null) {
    _.each(menuList.value, m => {
      if(m.menuUrl === menu.menuUrl) {
        m.open = !m.open;
      } else {
        m.open = false;
      }
    })
  }
}
const isActiveMenu = (menu) => {
  return route.fullPath.indexOf(menu.menuUrl) > -1;
}
</script>

<template>
  <div>
    <div class="title page-title">
      <h3>이용약관</h3>
    </div>
    <ul>
      <li :class="{'sub': menu.child.length > 0, 'on': isActiveMenu(menu), 'open': menu.open}" v-for="menu in menuList" @click="onClickMenu($event, menu)">
        <RouterLink v-if="menu.child.length === 0" :to="menu.menuUrl">{{ menu.menuName }}</RouterLink>
        <span v-if="menu.child.length > 0">{{ menu.menuName }}</span>
        <ul v-show="menu.open && menu.child.length > 0">
          <li class="sub-title" :class="{'on': isActiveMenu(childMenu)}" v-for="childMenu in menu.child">
            <RouterLink :to="childMenu.menuUrl">{{ childMenu.menuName }}</RouterLink>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import "../../assets/scss/theme";

.snb {
  float: left;
  width: 272px;
  ul {
    border: $border_line;
    padding: 24px;
    li {
      display: flex;
      align-items: center;
      @include font-size_md;
      border-bottom: $border_line;
      padding: 16px 0;
      &:first-child {
        padding-top: 0;
      }
      &:last-child {
        border-bottom: 0;
        padding-bottom: 0;
      }
      &.on {
        color: $blue_color;
        font-weight: 700;
      }
      i {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 18px;
        height: 18px;
        font-style: normal;
        @include font-size_xs;
        background: $red_color;
        color: #fff;
        border-radius: 50%;
        text-align: center;
        margin-left: 4px;
      }
    }
  }
}
</style>